module.exports = __webpack_public_path__ + "img/bh.7fcf1054.svg";